import { REQUEST } from '@/constants/api';

import { Feature } from '@/types/app-configurations';

import { axios } from './axios';

export const getFeatures = async () => {
  const result = await axios.get<Feature[]>(REQUEST.FEATURE.ROOT);

  return result.data;
};
